export default __webpack_public_path__ + "static/media/mask5.764af0bd.png";